import { createFileRoute, Link } from '@tanstack/react-router'

import Logo from '@/assets/logo.webp'
import OAKOICover from '@/assets/oakoi-cover.webp'
import MdiTable from '~icons/mdi/table'

export const Route = createFileRoute('/e/$eventId/landing')({
  component: RouteComponent,
})

function RouteComponent() {
  const { eventId } = Route.useParams()

  return (
    <div className="pt-safe botanical-bg relative flex min-h-dvh w-full flex-col gap-4 select-none">
      <div className="flex shrink-0 flex-col items-center justify-center gap-6 pt-12">
        <img
          draggable={false}
          src={Logo}
          alt="Event Logo"
          className="h-64 object-contain"
        />

        <Link
          to="/e/$eventId/map"
          params={{ eventId }}
          className="text-primary flex items-center gap-2 rounded-full bg-white/90 px-6 py-3 text-lg font-bold shadow-xl transition-all hover:bg-white active:scale-95"
        >
          <MdiTable className="size-6" />
          <span>ดูแผนผังที่นั่ง</span>
        </Link>
      </div>

      <div className="flex items-end justify-center">
        <img
          draggable={false}
          src={OAKOICover}
          alt="Event Cover"
          className="h-full object-cover object-top"
        />
      </div>
    </div>
  )
}
